import React from "react";
import useTitle from "../hooks/useTitle";

export default function Unauthorized() {
  useTitle("Unauthorized | Astro Portal");
  return (
    <div className="text-center mt-5">
      <h2 className="text-danger">🚫 Access Denied</h2>
      <p>You do not have permission to view this page.</p>
    </div>
  );
}
